
function div(className, parent, scroll) {
    let el = document.createElement('div');
    el.className = className;
    if (parent) {
        parent.appendChild(el);
    }
    if (scroll) {
        el.addEventListener('scroll', scroll);
    }
    return el;
}


/**
 * @mixin Element resize event mixin
 * Monitor `this.$el` for size change in the most efficient way compatible with this
 * browser, and call this.onResize() if one occurs.
 */
export default {
    data() {
        return {
            /**
             * True if we wish to monitor element width.
             */
            rseW: true,
            /**
             * True if we wish to monitor element height.
             */
            rseH: true
        };
    },

    mounted() {
        if (this.rseW || this.rseH) {
            if (window.ResizeObserver) {
                this.rso = new ResizeObserver(this.rsoEvent);
                this.rso.observe(this.$el);
            } else {
                this.rseInit();
                this.rseAppend();
            }
        }
    },

    updated() {
        if (this.rseel && this.rseel !== this.$el.lastChild) {
            this.rseAppend();
        }
    },

    beforeDestroy() {
        if (this.rso) {
            this.rso.disconnect();
        }
    },

    methods: {
        rseInit() {
            const rse = this.rseW ? this.rseH ? '_rsew _rseh' : '_rsew' : this.rseH ? '_rseh' : null;
            this.rseel = div(rse);
            div('_rsee', (this.rseele = div(rse, this.rseel, this.rseScroll)));
            div('_rses', (this.rseels = div(rse, this.rseel, this.rseScroll)));
        },

        rseAppend() {
            this.$el.appendChild(this.rseel);
            this.$nextTick(this.rseReset);
        },

        rseReset() {
            if (this.rseW) {
                this.rseele.scrollLeft =
                this.rseels.scrollLeft = 8192;
            }
            if (this.rseH) {
                this.rseele.scrollTop =
                this.rseels.scrollTop = 8192;
            }
        },

        rseScroll() {
            if (this.resize) {
                this.resize();
            }
            this.rseReset();
        },

        rsoEvent() {
            this.resize();
        }
    }
}
